import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <Link to="/" className='logo-link'><h2>FootyTick</h2></Link>
      </div>
      <ul onClick={toggleMenu} className={`navbar-links ${isMobileMenuOpen ? 'active' : ''}`}>
        <li onClick={toggleMenu}><Link to="/about-us" className='template-menu-item'>About Us</Link></li>
        <li onClick={toggleMenu}><Link to="/" className='template-menu-item'>EPL</Link></li>
        <li onClick={toggleMenu}><Link to="/la-liga" className='template-menu-item'>La Liga</Link></li>
        <li onClick={toggleMenu}><Link to="/bundes-liga" className='template-menu-item'>Bundesliga</Link></li>
        <li onClick={toggleMenu}><Link to="/serie-a" className='template-menu-item'>Serie A</Link></li>
        <li onClick={toggleMenu}><Link to="/ligue-1" className='template-menu-item'>Ligue 1</Link></li>
        <li onClick={toggleMenu}><Link to="/primeira-liga" className='template-menu-item'>Primeira Liga</Link></li>
        <li onClick={toggleMenu}><Link to="/eredivisie" className='template-menu-item'>Eredivisie</Link></li>
        <li onClick={toggleMenu}><Link to="/brasileiro-serie-a" className='template-menu-item'>Brasil Serie A</Link></li>
        <li onClick={toggleMenu}><Link to="/mls" className='template-menu-item'>MLS</Link></li>
        <li onClick={toggleMenu}><Link to="/spl" className='template-menu-item'>SPL</Link></li> 
        <li onClick={toggleMenu}><Link to="/csl" className='template-menu-item'>CSL</Link></li>
        {/*<li onClick={toggleMenu}><Link to="/league-tables" className='template-menu-item'>League Table</Link></li>
        <li onClick={toggleMenu}><Link to="/contact" className='site-menu-item'>Contact</Link></li>*/}
      </ul>
      <div className="hamburger" onClick={toggleMenu}>
        <div className="bar"></div>
        <div className="bar"></div>
        <div className="bar"></div>
      </div>
    </nav>
  );
};

export default Navbar;
